import React from 'react';
import IntroductionMenuItem from 'introduction/components/IntroductionMenuItem';
import OptionsMenuItem from 'options/components/OptionsMenuItem';
import ContactInfoMenuItem from 'contact-info/components/ContactInfoMenuItem';
import DissertationInfoMenuItem from 'dissertation-info/components/DissertationInfoMenuItem';
import FileUploadMenuItem from 'file-upload/components/FileUploadMenuItem';
import ReviewMenuItem from 'review/components/ReviewMenuItem';
import styles from './SubmissionPanelMenu.css';

const SubmissionPanelMenu = ({
  activeStep,
  contactInfoCompleted,
  onClickStep,
}) =>
  <nav className={styles.container}>
    <h2 className={styles.header}>Submission Steps</h2>
    <ul role="menu">
      <IntroductionMenuItem number={1} />
      <OptionsMenuItem number={2} />
      <ContactInfoMenuItem number={3} />
      <DissertationInfoMenuItem number={4} />
      <FileUploadMenuItem number={5} />
      <ReviewMenuItem number={6} />
    </ul>
  </nav>;

export default SubmissionPanelMenu;



// WEBPACK FOOTER //
// ./src/submission/components/SubmissionPanelMenu.js